import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { axiosClient } from '../config';
import { ApiResponse, ErrorResponse } from '@/shared/types';

// 응답 타입
export interface ContentCopyToAssetResponse {
  contentId: number;
  folderItemId: number;
  publicUrl: string;
}

type ResponseType = ApiResponse<ContentCopyToAssetResponse>;

// 요청 파라미터
interface PostContentCopyToAssetParams {
  contentId: number;
  currentSpaceId: number;
  targetSpaceId?: number;
  targetFolderId?: number;
  name?: string;
}

// API 함수
const postContentCopyToAssetApi = async ({
  contentId,
  currentSpaceId,
  targetSpaceId,
  targetFolderId,
  name,
}: PostContentCopyToAssetParams) => {
  const response = await axiosClient.post<ResponseType>(
    `/v1.0/content/${contentId}/copy-to-asset`,
    { targetSpaceId, targetFolderId, name },
    { params: { currentSpaceId } },
  );
  return response.data;
};

// React Query mutation 훅
export const usePostContentCopyToAssetApi = () => {
  return useMutation<
    ResponseType,
    AxiosError<ErrorResponse>,
    PostContentCopyToAssetParams
  >({
    mutationFn: postContentCopyToAssetApi,
  });
};
